export default class Address extends HTMLElement {
	constructor(){
		super();
        
        this.countrySelects = this.querySelectorAll("select[name='address[country]']")
		this.init();
	}

	init(){
        Array.prototype.slice.call(this.countrySelects).forEach((sel) => {
            sel.addEventListener("change", this.fillProvinceSelect);
          });
	}

    fillProvinceSelect(e) {
        // Currently the selected option defaults to the first child of the select element.
        // There is a data-default attribute on the select element which might be worth targeting for when an address located outside the United States is edited.
        const selectedOption = e.target.options[e.target.selectedIndex]
        const provinces = JSON.parse(selectedOption.dataset.provinces)
        const provinceOptionsFragment = document.createDocumentFragment()
        for (const province of provinces) {
          const option = document.createElement("option")
          option.value=province[0]
          option.text=province[1]
          provinceOptionsFragment.appendChild(option)
        }
        const provinceSelect = e.target.closest("form").querySelector("#AddressProvince")
        while (provinceSelect.firstChild) {
          provinceSelect.removeChild(provinceSelect.firstChild);
        }
        provinceSelect.appendChild(provinceOptionsFragment)
      }

}